<template>
  <img alt="dpcloud" class="zui-logo" :style="{ width: width, height: height }" :src="src" @click="onClick" />
</template>
<script>
import './less/logo.less';
import logo from './img/logo.png';
export default {
  name: 'Logo',
  props: {
    type: {
      default: 'dpcloud'
    },
    href: {
      default: ''
    },
    width: {
      default: ''
    },
    height: {
      default: ''
    }
  },
  computed: {
    src: function() {
      if (this.type === 'dpcloud') {
        return logo;
      }
    }
  },
  methods: {
    onClick: function(e) {
      if (this.type === 'dpcloud') {
        location.assign(this.href);
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/Logo.vue